import React from 'react';
import { Link } from 'react-router-dom';
import { Instagram, Mail } from 'lucide-react';
const TikTokIcon = ({
  className
}: {
  className?: string;
}) => <svg className={className} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" data-id="element-3475" data-mp="3r9170dt1ih42">
    <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5.8 20.1a6.34 6.34 0 0 0 10.86-4.43V8.86a8.16 8.16 0 0 0 4.77 1.52V6.93a4.85 4.85 0 0 1-1.84-.24z" data-id="element-3476" data-mp="3mfgbqtiu018k" />
  </svg>;
// Matches the header bar so the site's top and bottom chrome read as one system.
const FOOTER_BG = '#1E1E1E';
const FOOTER_BG_DARK = '#3A3A3A';
export function SiteFooter() {
  return <footer className="pt-8 pb-5 text-[#E8E4D8]" style={{
    backgroundColor: FOOTER_BG
  }} data-id="element-3477" data-mp="2yl577086c932">
      <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-3478" data-mp="11oxxk0li0s7r">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-8 mb-6" data-id="element-3479" data-mp="wta59cbpziy1">
          {[{
          heading: 'Shop',
          links: [{
            name: 'All Supplements',
            path: '/shop'
          }, {
            name: 'Best Sellers',
            path: '/shop?search=bestseller'
          }]
        }, {
          heading: 'Specificity',
          links: [{
            name: 'Performance',
            path: '/performance'
          }, {
            name: 'Gut Health',
            path: '/gut-health'
          }]
        }, {
          heading: 'Company',
          links: [{
            name: 'Support',
            path: '/contact'
          }, {
            name: 'My Account',
            path: '/account?tab=profile'
          }]
        }].map(column => <div key={column.heading} className="md:col-span-3" data-id="element-3480" data-mp="1jp1z1w3uzj5d">
              <h4 className="text-[11px] font-bold text-white uppercase tracking-[0.2em] mb-3" style={{
            fontWeight: "600",
            fontFamily: "Avenir, sans-serif"
          }} data-id="element-3481" data-mp="27fp8iltfagu1">
                {column.heading}
              </h4>
              <ul className="space-y-0.5" data-id="element-3482" data-mp="2m1uztynttjzl">
                {column.links.map(link => <li key={link.name} data-id="element-3483" data-mp="2h3l2piijk9bc">
                    <Link to={link.path} className="text-sm text-white hover:text-[#C8C4B0] transition-colors" data-id="element-3484" data-mp="2h4me5o3gyxtl">
                      {link.name}
                    </Link>
                  </li>)}
              </ul>
            </div>)}

          {/* Contact Col */}
          <div className="md:col-span-3" data-id="element-3485" data-mp="1yd3dhnwx3vuq">
            <h4 className="text-[11px] font-bold text-white uppercase tracking-[0.2em] mb-5" style={{
            fontWeight: "600",
            fontFamily: "Avenir, sans-serif"
          }} data-id="element-3486" data-mp="1yc0pbnqzc7ii">
              Contact
            </h4>
            <div className="flex items-center gap-4" data-id="element-3487" data-mp="1pehzm62e550a">
              <a href="https://www.tiktok.com/@structured.nutrition" target="_blank" rel="noopener noreferrer" aria-label="TikTok" className="text-white hover:text-[#C8C4B0] transition-colors" data-id="element-3488" data-mp="1ke3ryp4pbx2s">
                <TikTokIcon className="w-5 h-5" data-id="element-3489" data-mp="3w0e9pgkvywkd" />
              </a>
              <a href="https://www.instagram.com/structured.nutrition" target="_blank" rel="noopener noreferrer" aria-label="Instagram" className="text-white hover:text-[#C8C4B0] transition-colors" data-id="element-3490" data-mp="3w30dd54norxb">
                <Instagram className="w-5 h-5" data-id="element-3491" data-mp="3898jq8l8enwc" />
              </a>
              <Link to="/contact" onClick={() => window.scrollTo(0, 0)} aria-label="Contact" className="text-white hover:text-[#C8C4B0] transition-colors" data-id="element-3492" data-mp="3db7nhjkvvmtt">
                <Mail className="w-5 h-5" data-id="element-3493" data-mp="3m4ucmqul5ru1" />
              </Link>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t pt-5 flex flex-col md:flex-row items-center justify-between gap-4" style={{
        borderColor: FOOTER_BG_DARK
      }} data-id="element-3494" data-mp="2tlx5fyxo0psj">
          <p className="text-xs text-white" data-id="element-3495" data-mp="25j91ln54nhpp">
            © {new Date().getFullYear()} Structured Nutrition. All rights
            reserved.
          </p>
          <div className="flex items-center gap-6 text-xs text-white" data-id="element-3496" data-mp="2k8y5vr8io1u7">
            <Link to="/privacy" onClick={() => window.scrollTo(0, 0)} className="hover:text-white transition-colors" data-id="element-3497" data-mp="2fg4zz01bangj">
              Privacy Policy
            </Link>
            <Link to="/terms" onClick={() => window.scrollTo(0, 0)} className="hover:text-white transition-colors" data-id="element-3498" data-mp="2o8yv86x5lxg1">
              Terms of Service
            </Link>
          </div>
        </div>
      </div>
    </footer>;
}